import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    users: [
      { username: 'admin', password: 'admin123', role: 'admin' },
      { username: 'user', password: 'user123', role: 'user' }
    ]
  }),

  getters: {
    isAuthenticated: (state) => !!state.user,
    userRole: (state) => state.user?.role,
    isAdmin: (state) => state.user?.role === 'admin'
  },

  actions: {
    login(username, password) {
      const user = this.users.find(u => 
        u.username === username && u.password === password
      );
      
      if (user) {
        this.user = { ...user };
        localStorage.setItem('user', JSON.stringify(this.user));
        return true;
      }
      return false;
    },

    logout() {
      this.user = null;
      localStorage.removeItem('user');
    },

    initialize() {
      const user = localStorage.getItem('user');
      if (user) {
        this.user = JSON.parse(user);
      }
    }
  }
});